import { t } from "@travily/i18n";
import { WizardRichTextArea } from "@ui/components/WizardRichTextArea";
import type { ListingFieldCopy, ListingFieldProps, ListingType } from "./types";

const COLOR = "green" as const;

// i18n-tasks-use t('web.listings.fields.description.product.heading')
// i18n-tasks-use t('web.listings.fields.description.product.helper')
// i18n-tasks-use t('web.listings.fields.description.product.placeholder')
// i18n-tasks-use t('web.listings.fields.description.service.heading')
// i18n-tasks-use t('web.listings.fields.description.service.helper')
// i18n-tasks-use t('web.listings.fields.description.service.placeholder')

export function descriptionFieldCopy(listingType: ListingType): ListingFieldCopy {
  return {
    heading: t(`web.listings.fields.description.${listingType}.heading`),
    helper: t(`web.listings.fields.description.${listingType}.helper`),
  };
}

/**
 * `value` and `onChange` carry HTML — the description is an ActionText field on `Listing`,
 * shared by both listing types.
 */
export function DescriptionField({ error, listingType, onChange, value }: ListingFieldProps) {
  const { heading } = descriptionFieldCopy(listingType);

  return (
    <WizardRichTextArea
      color={COLOR}
      errorMessage={error}
      isInvalid={Boolean(error)}
      isLabelHidden
      label={heading}
      onChange={onChange}
      placeholder={t(`web.listings.fields.description.${listingType}.placeholder`)}
      value={value}
    />
  );
}
